import React from "react";
import * as constants from "../../../../EventSettings/constants";
import TextSetting from "../TextSetting";

const ScreenRegistrationSuccess = ({eventName, moduleSettings, onUpdate}) => {
    return (
        <>
            <TextSetting
                eventSetting={moduleSettings}
                title="Заголовок"
                rows={4}
                property={constants.SETTINGS_SUCCESS_TITLE}
                toggleProperty={constants.SETTINGS_HIDE_SUCCESS_TITLE}
                defaultText={constants.DEFAULT_CONFIRMATION_TITLE_SUCCESS(eventName)}
                onUpdate={onUpdate}
            />
            <TextSetting
                eventSetting={moduleSettings}
                title="Подзаголовок"
                rows={8}
                property={constants.SETTINGS_SUCCESS_SUBTITLE}
                toggleProperty={constants.SETTINGS_HIDE_SUCCESS_SUBTITLE}
                defaultText={constants.DEFAULT_CONFIRMATION_TEXT_SUCCESS}
                onUpdate={onUpdate}
            />
        </>
    );
};

export default ScreenRegistrationSuccess;
